package com.advaita.cloud.drive.ui.store

import com.advaita.cloud.drive.shared.PrincipalRef
import com.advaita.cloud.drive.shared.ShareLevels
import com.advaita.cloud.drive.shared.SourceStatus

/** The label of a share level. A grant that matches none of the three is "Custom". */
fun levelLabel(level: String): String = when (level) {
    ShareLevels.VIEWER -> "Viewer"
    ShareLevels.EDITOR -> "Editor"
    ShareLevels.COLLABORATOR -> "Collaborator"
    else -> "Custom"
}

/** The words for a person whom az2 no longer lists in the org (the DataHub backend ruling, item 1). */
const val FORMER_MEMBER = "Former member"

/** The words for a principal whose source did not answer, so its name is not known. */
const val NAME_UNAVAILABLE = "Name unavailable"

/**
 * The display name of a principal. [namesStatus] is the status of the source that names this
 * kind: `peopleStatus` for a USER, `teamsStatus` for a TEAM.
 *
 * - A USER with no name, while az2 answered, is a person az2 no longer lists: [FORMER_MEMBER].
 *   Example: Kai left, so his row on Project X reads "Former member".
 * - A TEAM with no name, while the vault answered, is a team the vault no longer lists.
 * - With the source down, the name is not known: [NAME_UNAVAILABLE].
 * - An ORG grant reaches everyone in the caller's own org.
 *
 * Never the id: az2's user id is an opaque hash, and it means nothing to a person.
 */
fun principalLabel(kind: String, ref: PrincipalRef, namesStatus: String?): String {
    ref.name?.takeIf { it.isNotBlank() }?.let { return it }
    val sourceAnswered = namesStatus == SourceStatus.OK
    return when (kind) {
        "ORG" -> "Everyone in your organization"
        "TEAM" -> if (sourceAnswered) "Deleted team" else NAME_UNAVAILABLE
        else -> if (sourceAnswered) FORMER_MEMBER else NAME_UNAVAILABLE
    }
}
